<template>
	<div class="head-box" :style="lineProgress">
		<div>
			<van-tabs v-model="active">
			  <van-tab title="首页" to="/homePhone"></van-tab>
			  <van-tab title="漏洞列表" to="/bugListphone"></van-tab>
<!--			  <van-tab title="热点事件" to="/focus"></van-tab>-->
<!--			  <van-tab title="安全公告" to="/noticePhone"></van-tab>-->
				<van-tab title="漏洞统计" to="/bugEchartsPhone"></van-tab>
			</van-tabs>
		</div>
		<!-- <van-tabs v-model="active" swipeable line-height="1px" style="height: 49px;z-index: 1000;">
			<van-tab to="/homePhone" title="首页" title-style="width:20%;flex-basis:20%;font-size: .16rem;color: #999;"></van-tab>
			<van-tab to="/bugListphone" title="漏洞列表" title-style="width:20%;flex-basis:20%;font-size: .16rem;color: #999;"></van-tab>
			<van-tab to="/focus" title="热点事件" title-style="width:20%;flex-basis:20%;font-size: .16rem;color: #999;"></van-tab>
			<van-tab to="/noticePhone" title="安全公告" title-style="width:20%;flex-basis:20%;font-size: .16rem;color: #999;"></van-tab>
			<van-tab to="/bugEchartsPhone" title="漏洞统计" title-style="width:20%;flex-basis:20%;font-size: .16rem;color: #999;"></van-tab>
		</van-tabs> -->
	</div>
</template>

<script>
	export default {
		name: "hed",
		computed: {
			lineProgress() {
				const style = {}
				style.width = this.screenWidth + 'px';
				return style
			}
		},
		data() {
			return {
				active: 0,
			};
		},
		created() {

		},
		watch: {
			$route: {
				handler: function(val, oldVal) {
					if (JSON.stringify(val.meta) != '{}') {
						this.active = val.meta.num
					}
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style scoped>
	/deep/ .van-tab--active {
		color: #2874be !important;
		font-weight: 700;
	}

	/deep/ .van-tabs__line {
		position: absolute;
		bottom: 15px;
		left: 0;
		z-index: 1;
		height: 3px;
		background-color: #2874be;
		border-radius: 3px;
	}

	/deep/ .van-tabs__nav {
		background: transparent;
	}

	/* /deep/ .van-tabs__wrap {
		height: 49px;
	} */
</style>
